<mat-form-field class="w-100">
    <mat-label>{{ postcodeLabel | translate }}</mat-label>
    <input
        type="text"
        #searchPostCode
        id="searchPostcode"
        matInput
        [formControl]="searchPostcodeForm"
        [matAutocomplete]="auto"
        (focus)="onFocus($event)"
    />
    <!--(keydown.backspace)="clear()"-->
    <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="getOptionText"
        (optionSelected)="onSelect($event)"
        [autoActiveFirstOption]="true"
        aria-label="searchPostcode"
    >
        @for (result of results; track result) {
<mat-option
           
            [value]="result"
            [id]="generateOptionId(result)"
            [attr.aria-selected]="isOptionSelected(result) ? 'true' : 'false'"
            [tabindex]="-1"
            (mouseenter)="updateActiveOption(generateOptionId(result))"
            (mouseleave)="updateActiveOption(null)"
        >
            {{ getLocalizedName(result) }}
            {{ result.name }}
            {{ result.postcode }}
        </mat-option>
}
    </mat-autocomplete>
    <fa-icon class="loader" [class.shown]="loading" [icon]="icons.falSpinnerThird" animation="spin"></fa-icon>
</mat-form-field>

<mat-form-field class="w-100">
    <mat-label>{{ streetLabel | translate }}</mat-label>
    <input type="text" #searchArea id="searchArea" matInput [formControl]="searchStreetForm" [matAutocomplete]="auto2" (focus)="onFocus($event)" />
    <!--(keydown.backspace)="clear()"-->
    <mat-autocomplete
        #auto2="matAutocomplete"
        [displayWith]="getOptionText"
        (optionSelected)="onSelect($event)"
        [autoActiveFirstOption]="true"
        aria-label="searchArea"
    >
        @for (result2 of results2; track result2) {
<mat-option
           
            [value]="result2"
            [id]="generateOptionId(result2)"
            [attr.aria-selected]="isOptionSelected(result2) ? 'true' : 'false'"
            [tabindex]="-1"
            (mouseenter)="updateActiveOption(generateOptionId(result2))"
            (mouseleave)="updateActiveOption(null)"
        >
            {{ result2.name }}
        </mat-option>
}
    </mat-autocomplete>
    <fa-icon class="loader" [class.shown]="loading" [icon]="icons.falSpinnerThird" animation="spin"></fa-icon>
</mat-form-field>

